import React, {useEffect, useState} from "react";
import {useForm, SubmitHandler, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

// import redux
import {useSelector, useDispatch} from "react-redux";
import {RootState} from "../../features/store";
import {modalCloseAction} from "../../features/sliceReducer/interactionReducer";
import {updateFactory} from "../../features/sliceReducer/factoryListReducer";

//import model
import {initializeIPFactory, IPFactory} from "../../models/IPFactory";
import {factorySchema} from "../../validation/factorySchema";

//import material-UI
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import {Box, Button, IconButton, Modal, TextField, Typography} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import BackupIcon from "@material-ui/icons/Backup";
import IPUtility from "../../classes/IPUtility";
import {createFactory} from "../../features/sliceReducer/factoryListReducer";
// import he from "date-fns/esm/locale/he/index.js";

//use styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.text.primary,
    },
    paper: {
      width: "860px",
      height: "640px",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(6, 14, 3),
    },
    modalTitle: {
      marginBottom: " 30px",
    },
    inputStyle: {
      marginBottom: "20px",
      backgroundColor: theme.palette.input.main,
    },
    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        // marginTop: "80px",
      },
    },
    fileUploadContainer: {
      // display: "flex",
      // justifyContent: "space-between",
      width: "100%",
      marginTop: "10px",
      marginBottom: "30px",
      border: "1px solid rgba(0, 0, 0, 0.2)",
      backgroundColor: theme.palette.input.main,
    },
    imageBox: {
      maxWidth: "100%",
      height: "120px",
      marginBottom: "16px",
      paddingLeft: "12px",

      "& img": {
        height: "100%",
      },
    },
  })
);

const FactoryModalForm = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {currentFactory, factoryEditSwitch} = useSelector((state: RootState) => state.factoryList);
  const {modalToggle} = useSelector((state: RootState) => state.interaction);
  const {userToken} = useSelector((state: RootState) => state.auth);
  const [imgSrc, setImgSrc] = useState("");
  const [logoFileName, setLogoFileName] = useState("");

  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: {errors, isValid},
  } = useForm<IPFactory>({resolver: yupResolver(factorySchema)});

  useEffect(() => {
    reset({...currentFactory});
    if (currentFactory.logoFile && currentFactory.logoFile.length > 0) {
      setImgSrc("/uploads/inspect/companyLogo/" + currentFactory.logoFile);
    } else {
      setImgSrc("");
    }
    setLogoFileName(currentFactory.logoFile);
  }, [currentFactory]);

  const onSubmit: SubmitHandler<IPFactory> = async (data) => {
    await new Promise((resolve, reject) =>
      factoryEditSwitch
        ? resolve(dispatch(updateFactory({userToken, item: data})))
        : resolve(dispatch(createFactory({userToken, item: data})))
    );
    isValid && reset({...initializeIPFactory});
    // console.log(data);
  };
  // console.log(currentFactory);

  // ImageLoaded - 2021-12-27 추가
  const imageLoaded = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(currentFactory.base64);
    e.preventDefault();
    const fileList = e.target.files;
    if (fileList !== undefined && fileList !== null && fileList.length > 0) {
      var file = fileList[0];
      IPUtility.getFile(file).then((fileInfoData) => {
        const logoFile = fileInfoData.fileName;
        const base64 = "data:" + fileInfoData.fileType + ";base64," + fileInfoData.base64StringFile;
        setImgSrc(base64);
        setLogoFileName(logoFile);
        setValue("base64", base64);
        setValue("logoFile", logoFile);
      });
    }
  };
  // console.log(factory);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={modalToggle}
      onClose={() => {
        dispatch(modalCloseAction());
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={modalToggle}>
        <form>
          <Box px={3} py={2} className={classes.paper}>
            <Typography className={classes.modalTitle} variant="h6" align="center">
              {factoryEditSwitch ? "사업장 수정" : "사업장 추가"}
            </Typography>
            <Controller
              name="name"
              control={control}
              defaultValue={currentFactory.name}
              render={({field}) => (
                <TextField
                  {...field}
                  className={classes.inputStyle}
                  required
                  label="사업장명"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  error={errors.name ? true : false}
                />
              )}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.name?.message}
            </Typography>
            <Controller
              name="initial"
              control={control}
              defaultValue={currentFactory.initial}
              render={({field}) => (
                <TextField
                  {...field}
                  className={classes.inputStyle}
                  required
                  label="사업장코드"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  error={errors.initial ? true : false}
                />
              )}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.initial?.message}
            </Typography>
            <Controller
              name="description"
              control={control}
              defaultValue={currentFactory.description}
              render={({field}) => (
                <TextField
                  {...field}
                  defaultValue={currentFactory.description}
                  className={classes.inputStyle}
                  required
                  label="사업장설명"
                  fullWidth
                  multiline
                  maxRows={4}
                  variant="outlined"
                  margin="dense"
                  error={errors.description ? true : false}
                />
              )}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.description?.message}
            </Typography>
            <Typography variant="inherit" color="textSecondary">
              {errors.logoFile?.message}
            </Typography>
            <Box className={classes.fileUploadContainer}>
              <Box>
                <input
                  accept="image/*"
                  capture="camera"
                  onChange={imageLoaded}
                  style={{display: "none"}}
                  id="icon-button-logoImage"
                  type="file"
                />
                <label htmlFor="icon-button-logoImage">
                  <IconButton color="primary" aria-label="upload picture2" component="span">
                    <BackupIcon />
                  </IconButton>
                </label>
                <span>{logoFileName}</span>
              </Box>
              <div className={classes.imageBox}>
                {imgSrc && imgSrc.length > 0 && <img src={imgSrc} alt={logoFileName} />}
              </div>
            </Box>
            <Box className={classes.buttonStyle}>
              <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>
                등록
              </Button>
            </Box>
          </Box>
        </form>
      </Fade>
    </Modal>
  );
};

export default FactoryModalForm;
